








import {Component, Vue} from 'vue-property-decorator';
import ImageLayout from '@/components/ImageLayout.vue';

@Component({
  components: {
    ImageLayout,
  },
})
export default class ChangePasswordSuccess extends Vue {
}
